import { Box, Typography, Button } from '@mui/material';
import useAuth from '../hooks/useAuth';

export const BANNER_HEIGHT = 40;

export default function ImpersonationBanner() {
  const { isImpersonating, user, leaveImpersonation } = useAuth();

  if (!isImpersonating) return null;

  const userName = user ? `${user.first_name} ${user.last_name}` : 'Unknown User';

  return (
    <Box
      data-testid="impersonation-banner"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: BANNER_HEIGHT,
        bgcolor: '#f59e0b',
        color: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: (theme) => theme.zIndex.appBar + 10,
        px: 2,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        You are viewing as {userName} &mdash;
      </Typography>
      <Button
        size="small"
        variant="text"
        onClick={leaveImpersonation}
        data-testid="exit-impersonation-btn"
        sx={{
          color: '#000',
          fontWeight: 700,
          textDecoration: 'underline',
          ml: 0.5,
          '&:hover': { bgcolor: 'rgba(0,0,0,0.1)' },
        }}
      >
        Exit Impersonation
      </Button>
    </Box>
  );
}
